<template>
  <!-- The one loader (Loader.vue), in place of grey placeholder rows. -->
  <Loader class="py-12" />
</template>

<script>
import Loader from '@components/Loader'

export default {
  components: {
    Loader
  },
  props: {
    // Kept so callers that pass it still work.
    cols: {
      type: Number,
      default: 3
    }
  }
}
</script>
